import { useSessionPermission } from '@btime/react-session'

import { useOpenEditGroupModal } from '../../routes/modals/modalsActions'
import { useRemoveGroups } from './_requests/removeGroups'

export const useGroupEditAction = item => {
  const openEditModal = useOpenEditGroupModal()
  const canEdit = useSessionPermission('setupUser')

  return {
    click: () => openEditModal({ id: item.id }),
    hasPermission: canEdit
  }
}

export const useGroupRemoveAction = item => {
  const canDelete = useSessionPermission('setupUser')
  const [deleteItems, { loading }] = useRemoveGroups()

  return {
    click: () => deleteItems([item.id]),
    hasPermission: canDelete
  }
}

export const useGroupsRemoveAction = ids => {
  const canDelete = useSessionPermission('setupUser')
  const [deleteItems, { loading }] = useRemoveGroups()

  return {
    click: () => deleteItems(ids),
    hasPermission: canDelete
  }
}
